import { useFormConfig } from './hooks/useFormConfig'
import { useTexts } from './hooks/useTexts'
import { form } from './formState'
import { Footer } from './components/Footer'
import { useOnSubmit } from './hooks/useOnSubmit'
import { SummarizeFutureMobileRoute } from './fields/SummarizeFutureMobileRoute/SummarizeFutureMobileRoute'
import { MobileFutureDaysVisibility } from './fields/MobileFutureDaysVisibility/MobileFutureDaysVisibility'

type BulkDriverFormProps = {
  drivers: uui.domain.client.rm.ExtendedDriver[]
}

export function BulkDriverForm(props: BulkDriverFormProps) {
  const { drivers } = props
  const { header, driverAppTitle } = useTexts()

  const config = useFormConfig(drivers)
  const onSubmit = useOnSubmit(drivers)

  return (
    <form.Form
      title={header.title(drivers.length)}
      testId="bulk-driver-form"
      config={config}
      onSubmit={onSubmit}
      requireTransaction
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
      rightBorder
      footer={<Footer />}
    >
      <form.SectionTitle>{driverAppTitle}</form.SectionTitle>
      <MobileFutureDaysVisibility />
      <SummarizeFutureMobileRoute />
    </form.Form>
  )
}
